<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品子类型-修改
    -->
  <el-dialog title="修改子类型" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form" :label-width="formLabelWidth">


      <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>


      <!-- <el-form-item label="价格" prop="price" :label-width="formLabelWidth">
        <el-input v-model="form.price" autocomplete="off"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="单位" prop="unit" :label-width="formLabelWidth">
        <el-input v-model="form.unit" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="计价方式" prop="price_method" :label-width="formLabelWidth">
        <el-input v-model="form.price_method" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="最小长度 (-1 不限制)" prop="min_length" :label-width="formLabelWidth">
        <el-input v-model.number="form.min_length" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="最大长度 (-1 不限制)" prop="max_length" :label-width="formLabelWidth">
        <el-input v-model.number="form.max_length" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="最小宽度 (-1 不限制)" prop="min_width" :label-width="formLabelWidth">
        <el-input v-model.number="form.min_width" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="最大宽度 (-1 不限制)" prop="max_width" :label-width="formLabelWidth">
        <el-input v-model.number="form.max_width" autocomplete="off"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="计价公式" prop="formula" :label-width="formLabelWidth">
        <el-input v-model="form.formula" autocomplete="off"></el-input>
      </el-form-item> -->


      <el-form-item label="产能" prop="capacity" :label-width="formLabelWidth">
        <el-input v-model.number="form.capacity" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
 
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <Upload v-if="isupload1" :isupload="isupload1" :type="type1" @returnImgs="returnImgsFunc1">上传图片</Upload>
  </el-dialog>
</template>

<script>
    import HproductApi from '@/api/hproduct.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        form: {
          category_id: 0,
          parent_id: 0,
          name: '',
          image_id: '',
          image_id_1: '',
          sort: '',
          val:"",
          code:"text",
        },
        file_path: '',
        formRules: {

        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
        isupload1: false,
        file_path_1:'',
        type:[
 
        {
          label:"颜色",
          val:"color"
        },
        {
          label:"颜色色块",
          val:"colors"
        },
        {
          label:"输入框",
          val:"input"
        }, {
          label:"选择",
          val:"choose"
        },
      ]
      };
    },
    props: ['open_edit', 'hproduct_subcategory_id'],
    created() {
      this.dialogVisible = this.open_edit;
      
      this.getDetail();
    },
    methods: {
      /*修改用户*/
      addUser() {
        let self = this;
        let params = self.form;
        params.hproduct_subcategory_id = self.hproduct_subcategory_id;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            HproductApi.subcategory_edit(params, true).then(data => {
              self.loading = false;
              self.$message({
                message: '修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },
      getDetail() {
      let self = this;
      // 取到路由带过来的子类型
      HproductApi.subcategory_detail({hproduct_subcategory_id: self.hproduct_subcategory_id},true).then(res => {
          self.form = res.data;
          self.loading = false;
         
        })
        .catch(error => {});
    },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*上传*/
      openUpload1(e) {
        this.type1 = e;
        this.isupload1 = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },
      /*获取图片*/
      returnImgsFunc1(e) {
        if (e != null && e.length > 0) {
          this.file_path_1 = e[0].file_path;
          this.form.image_id_1 = e[0].file_id;
        }
        // console.log(this.file_path_1);
        this.isupload1 = false;
      },

    }
  };
</script>

<style>
  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/hproduct/subcategory/Edit.vue